// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.button--agent[data-v-670bbcfa]{transition:opacity .25s ease,background-color .25s ease;line-height:1.6rem;font-size:1.4rem;display:flex;position:fixed;z-index:10;right:2.4rem;bottom:2.4rem}.button--agent[data-v-670bbcfa]:not(.show){opacity:0;pointer-events:none}.button--agent svg[data-v-670bbcfa]{height:1.6rem;width:1.6rem;margin-right:.4rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
